/*global swal*/

import './style.less';
import { keyBy } from 'lodash';

export default function($log, $state, ProfileClass, ApiClass, Swal) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.delete = tagCategory => {
    Swal.confirm(
      'Delete Category?',
      `This will remove the tag category "${tagCategory.name}" and all it's associated tags.`
    )
      .then(() => {
        return ApiClass.companiesIdTypeTypeIdDelete({
          manage: true,
          id: company_id,
          type: 'tagCategories',
          type_id: tagCategory.uuid
        });
      })
      .then(() => {
        _toast('Category Deleted!');
        tagCategory.archived = true;
      })
      .catch(error => {
        if (error.dismiss || error.message === 'exit') return;
        $log.error(error);
        throw error;
      });
  };

  vm.add = name => {
    vm.laddaAdd = true;
    ApiClass.companiesIdTypePut({ manage: true, id: company_id, type: 'tagCategories' }, { name })
      .then(({ data: { item } }) => {
        $state.go('.id', { type_id: item.uuid });
        cleanForm();
        expose([{ tagCategory: item, tags: [] }, ...vm.tags]);
        vm.laddaAdd = false;
      })
      .catch(error => {
        vm.laddaAdd = false;
        $log.error(error);
        throw error;
      });
  };

  vm.updateStatus = (tagCategory, active) => {
    ApiClass.companiesIdTypeTypeIdPatch(
      {
        manage: true,
        id: company_id,
        type: 'tagCategories',
        type_id: tagCategory.uuid
      },
      { active }
    )
      .then(() => {
        _toast('Category Updated!');
        activate();
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function cleanForm() {
    delete vm.name;
    vm.tagCategoryForm.$setPristine();
    vm.tagCategoryForm.$setUntouched();
  }

  function countTags({ tagCategory, tags }) {
    tagCategory.count = Object.values(tags || {}).filter(({ archived }) => !archived).length;
    return { tagCategory, tags };
  }

  function expose(tags) {
    vm.tags = Object.assign([], tags)
      .filter(({ tagCategory }) => tagCategory)
      .map(countTags);
    vm.tagsDict = keyBy(tags, 'id');
  }

  function _toast(message) {
    Swal.toast(message);
  }

  function activate() {
    $log.debug('tags Controller Activated');
    ApiClass.companiesIdTypeGet({ manage: true, id: company_id, type: 'tagCategories' })
      .then(({ data: { items: tagCategory } }) => expose(tagCategory))
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/tags/get/index.js